import { useMemo } from "react";
import {
  buildWorkspaceGistTree,
  flattenWorkspaceGistTree,
} from "../model/buildWorkspaceGistTree";
import { getWorkspaceNavigationCounts } from "../model/getWorkspaceNavigationCounts";
import type { UseWorkspaceGistNavigationArgs } from "../model/workspaceNavigationTypes";

export function useWorkspaceGistNavigation({
  gists,
  currentGistId,
  selectedSubjectId,
  sortGists,
}: UseWorkspaceGistNavigationArgs) {
  const tree = useMemo(
    () => buildWorkspaceGistTree(gists, { sortGists }),
    [gists, sortGists],
  );

  const rows = useMemo(
    () => flattenWorkspaceGistTree(tree, currentGistId, gists),
    [currentGistId, gists, tree],
  );

  const counts = useMemo(
    () => getWorkspaceNavigationCounts(gists, { selectedSubjectId, sortGists }),
    [gists, selectedSubjectId, sortGists],
  );

  const currentRow = useMemo(
    () => rows.find((row) => row.isCurrent) || null,
    [rows],
  );

  return {
    tree,
    rows,
    counts,
    currentRow,
  };
}
